module.exports = __webpack_public_path__ + "img/nightcastle-throne.1145ac20.webp";